

findEditableTypes = (tagTypes) ->
    editableTypes = []
    for group in tagTypes
        for tag in group.types
            editableTypes.push tag if tag.editable
    return editableTypes


TagFormController = ($scope, $q, TagService) ->
    'ngInject'

    vm = @
    isEditing = @tag?.id?
    @tag = {} if not isEditing

    watchExp = [vm.getSlug, -> vm.tagTypes]
    revalidateName = -> vm.form?.ngForm.name?.$validate()
    $scope.$watchGroup(watchExp, revalidateName)

    @validateName = (name) ->
        return TagService.validateName(vm.getSlug(), name, vm.program, vm.tag)
            .catch (tag) ->
                vm.existing = tag
                return $q.reject(tag)

    @getSlug = ->
        if isEditing then return vm.tag?.slug
        else if vm.tagTypes.length == 1 then return vm.tagTypes[0].slug
        else return vm.form.formData.slug?.slug

    @save = (data) =>
        if isEditing then return update(data)
        else return create(data)

    @delete = (data) ->
        return TagService.delete(vm.tag).then ->
            vm.onDelete(tag: vm.tag)
            return

    update = (data) ->
        return TagService.update(vm.tag, data.name, data.description)
            .then (tag) ->
                angular.extend(vm.tag, tag)
                vm.onSave(tag: vm.tag)

    create = (data) ->
        result = TagService.create(vm.getSlug(),
                                   data.name,
                                   data.description,
                                   vm.program)
        return result.then (tag) -> vm.onSave(tag: tag)

    return


tagFormComponent =
    controller: TagFormController
    templateUrl: 'tags/tagForm'
    controllerAs: 'tagForm'
    bindings:
        tag: '=?',
        program: '=',
        tagTypes: '='

        onDelete: '&'
        onSave: '&'
        onClose: '&'


module.component 'tagForm', tagFormComponent
